export interface CreativeValidationErrorMessageParams {
  width?: number;
  height?: number;
  maxSizeKb?: number;
}

export interface DecodedCreativeValidationErrorMessage {
  key: string;
  params?: CreativeValidationErrorMessageParams;
}

interface EncodedCreativeValidationErrorMessage {
  key: string;
  params: CreativeValidationErrorMessageParams;
}

export function encodeCreativeValidationErrorMessage(
  key: string,
  params?: CreativeValidationErrorMessageParams,
): string {
  if (!params) {
    return key;
  }

  const encodedMessage: EncodedCreativeValidationErrorMessage = { key, params };
  return JSON.stringify(encodedMessage);
}

export function decodeCreativeValidationErrorMessage(message: string): DecodedCreativeValidationErrorMessage {
  if (!message.startsWith('{')) {
    return { key: message };
  }

  try {
    const parsedMessage = JSON.parse(message) as EncodedCreativeValidationErrorMessage;

    if (typeof parsedMessage.key === 'string') {
      return {
        key: parsedMessage.key,
        params: parsedMessage.params,
      };
    }
  } catch {
    return { key: message };
  }

  return { key: message };
}
